export const ACTION_EVENTS = {
  CLEAR_CHAT: "CLEAR_CHAT",
  CLOSE_PANEL: "CLOSE_PANEL",
  SEND_MESSAGE: "SEND_MESSAGE",
};

export const CONTEXT_FIELDS = {
  MYP_CONTENT: "mypContent",
  AI_INSTRUCTIONS: "aiInstructions",
  LEARNING_STANDARD_PYP: "benchmarks",
  TYPE_OF_QUESTIONS: "typeOfQuestions",
  NUMBER_OF_QUESTIONS: "numberOfQuestions",
  SYLLABUS_CONTENT_DP: "syllabusContentDP",
  LEARNING_STANDARD_UBD: "learningStandardUBD",
};

export const getWorksheetContextFields = ({ t, data, entityType }) => {
  const QUESTION_TYPE_AND_COUNT = [
    {
      id: CONTEXT_FIELDS.TYPE_OF_QUESTIONS,
      label: t("worksheet:question_type"),
      value: data[CONTEXT_FIELDS.TYPE_OF_QUESTIONS] || "AUTO",
      displayValue: data[CONTEXT_FIELDS.TYPE_OF_QUESTIONS] || "Auto",
      isRequired: true,
      isDisabled: false,
      customComponent: null,
    },
    {
      id: CONTEXT_FIELDS.NUMBER_OF_QUESTIONS,
      label: t("worksheet:number_of_questions"),
      value: data[CONTEXT_FIELDS.NUMBER_OF_QUESTIONS] || 0,
      displayValue:
        data[CONTEXT_FIELDS.NUMBER_OF_QUESTIONS] > 0
          ? data[CONTEXT_FIELDS.NUMBER_OF_QUESTIONS]
          : "0",
      isRequired: true,
      isDisabled: false,
      customComponent: null,
    },
  ];

  let fields = [];

  if (entityType === "ASSESSMENT") {
    fields = fields.concat(QUESTION_TYPE_AND_COUNT);
  }

  return fields;
};
